import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import AprovacaoVendasAtendimentoProvider from "./AprovacaoVendasAtendimentoContext";
import PesquisarAprovacaoVendasAtendimento from "./Events/PesquisarAprovacaoVendasAtendimento";

const Index = () => {
  let match = useRouteMatch();
  return (
    <AprovacaoVendasAtendimentoProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarAprovacaoVendasAtendimento}
          />
        </Switch>
      </div>
    </AprovacaoVendasAtendimentoProvider>
  );
};

export default Index;
